"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractorStatusEnum = void 0;
/** Статус контрактора на услуги */
var UserServiceContractorStatusEnum;
(function (UserServiceContractorStatusEnum) {
  /**
   * Ожидает подтверждения
   * = Выставлен счёт для оплату контракта
   */
  UserServiceContractorStatusEnum[UserServiceContractorStatusEnum["accepting"] = 10] = "accepting";
  /**
   * Прервал запись на занятия
   * = Не оплатил выставленный счёт для заключения контракта
   */
  UserServiceContractorStatusEnum[UserServiceContractorStatusEnum["accept_broken"] = 15] = "accept_broken";
  /**
   * Подтверждён
   * = Оплатил выставленный счёт для заключения контракта
   * = Оплатил выставленный счёт для продления контракта
   */
  UserServiceContractorStatusEnum[UserServiceContractorStatusEnum["accepted"] = 20] = "accepted";
  /**
   * Прекратил занятия по своей воле
   * = Выполнил действие "Прервать занятия"
   * = Выполнил действие "Прекратить подписку"
   */
  UserServiceContractorStatusEnum[UserServiceContractorStatusEnum["canceled"] = 25] = "canceled";
  /**
   * Приостановлен
   * = Не смог оплатить продление контракта
   */
  UserServiceContractorStatusEnum[UserServiceContractorStatusEnum["suspended"] = 30] = "suspended";
  /**
   * Прервал занятия по причине не оплаты
   * = Не оплатил продление
   */
  UserServiceContractorStatusEnum[UserServiceContractorStatusEnum["prolong_broken"] = 35] = "prolong_broken";
})(UserServiceContractorStatusEnum = exports.UserServiceContractorStatusEnum || (exports.UserServiceContractorStatusEnum = {}));
